
import version from "./version.json"

export default {
	buildCheckInterval: 10, //minutes
	version: version,
	portal: {
		companyName: "Apleona",
		title: "Reporting",
		apps: ["auth", "site", 'minimaster', 'reports', 'quentic'],
		defaultApp: "minimaster", //default app if no userConfig
		lockApp: "auth", //timeout lock app
		languages: ['en'],
		defaultLanguage: 'en',
		api: {
			// protocol: 'https://',
			// server: 'reporting.apleona.com',
			protocol: process.env.VUE_APP_API_PROTOCOL,
			server: process.env.VUE_APP_API_SERVER,
			baseUrl: "/api/",
			loginUrl: "auth/login"
		},
		loadDelay: 200, // show Delay after
		loadTimeout: 5000, // show Timeout after
		//list not supported browser
		//syntax: https://github.com/lancedikson/bowser
		browserSupport: {
			rip: {
				ie: '>1'
			},
			notSupported: null
		},
		//list browser with credential API
		//https://caniuse.com/#feat=credential-management
		//syntax: https://github.com/lancedikson/bowser
		credentialApiSupport: {
			chrome: '>=57',
			edge: '>=79',
			opera: '>=45',
			android: '>=81',
			samsung_internet: '>=7.2',
			uc: '>=12.12'
		}
	},

	debug: {
		development: {
			//level: 'DEBUG',
			//namespaces: 'DEBUG:portal,ERROR:*',
			//namespaces: 'DEBUG:portal:*',
			json: false,
			serverinfo: false,
			hideDate: false,
			colors: false,
		},
		production: {
			level: 'ERROR',
			namespaces: '*',
			json: false,
			serverinfo: false,
			hideDate: false,
			colors: true,
		}
	},
	//apps config
}

